/*
 * Project: LegalPlace assistant
 * File: src/logic/preview_render/angular_reader.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import 'chalk';
// import lpApp from '../../app/lp_app';

export default class LpOutput {
  constructor(id, text, varId = -1, variablesIndex) {
    this.id = id;
    this.raw = text;
    this.variables = [];
    this.variablesIndex = variablesIndex;
    this.compiled = '';
    this.actual_variable = varId;
    // console.log(this.id);
    // console.log(text);
  }

  compile() {
    // FIXME: we can optimize this
    // TODO: Add all the compiled outputs to the windowDOM
    // const reg_test = /<(p|span)\s(\s|\w|=|\\|"|-|:|\[|\]|\$|\.|\'|\/)+>/img;
    const initThing = /<span ng-init=\"(\w|\[|\]|\s|=|\.)+\"\sng-include=\"\'preview\/var\.html\'\"><\/span>/gm; // eslint-disable-line
    const replacedThings = this.raw.match(initThing);
    let res = this.raw;
    const varExtractor = /contractCtrl.variables.wrapper\[(\d+)\]/gm;
    if (replacedThings === null || replacedThings.length === 0) {
      this.compiled = this.raw;
      return this;
    }
    replacedThings.forEach((idx) => {
      let m;
      let varId;
      while (m = varExtractor.exec(idx)) {
        // add the copy name
        [, varId] = m;
        if (typeof this.id === 'string') {
          // Checking if variable is a child
          // let children = lpApp.utils.getAllChildren(this.id.split('_')[0]);
          // console.log(children)
          if (typeof (this.variablesIndex) === 'object') {
            if (this.variablesIndex.includes(parseInt(varId, 10))) {
              varId = `${varId}_${this.id.split('_')[1]}`;
            }
          } else {
            varId = `${varId}_${this.id.split('_')[1]}`;
          }
        }
        this.variables.push(varId);
      }
      res = res.replace(idx, `<span class="am_a_var" data-var-id="${varId}">{{${varId}}}</span>`);
    }, this);
    // this.compiled = res;
    this.compiled = res;

    return this;
  }

  draw(vas = []) {
    if (vas.length !== this.variables.length) return '';
    let result = this.compiled.slice(0);
    // filterNumbers(this.compiled).slice(0); // clone

    let i = 0;
    // if(vas[0] != "" && this.id == 285)debugger;
    this.variables.forEach((idx) => {
      const cIdx = idx;
      // Converting to string if it's a number
      if(typeof(vas[i]) === 'number')
        vas[i] = vas[i].toString();

      if (idx === this.actual_variable) {
        if (vas[i] === '' || typeof (vas[i]) === 'undefined') result = result.replace(`{{${cIdx}}}`, '<span class="doc-highlight">_______________________</span>');
        else {
          const res = vas[i].replace(/<br>/g, '\n').replace(/</g, '&lt;').replace(/\n/g, '<br>');
          result = result.replace(`{{${cIdx}}}`, `<span class="doc-highlight">${res}</span>`);
        }
      } else if (vas[i] === '' || typeof (vas[i]) === 'undefined') result = result.replace(`{{${cIdx}}}`, '_______________________');
      else {
        const res = vas[i].replace(/<br>/g, '\n').replace(/</g, '&lt;').replace(/\n/g, '<br>');
        result = result.replace(`{{${cIdx}}}`, res);
      }
      i += 1;
    }, this);
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/logic/preview_render/angular_reader.js